import {Moment} from 'moment';

export type DatepickerValue = Moment | null;
